import { pluralize } from '#pluralize';

export function getPointsLabel(num: number): string {
  return `${num} ${pluralize(num, { one: 'punkt', few: 'punkty', many: 'punktów' })}`;
}
